
export default {
  banner: {
    title: "New virtual battery in 2026 – Energy provider Ohm Energie launches new offer",
    button: "See conditions",
  },
  partner: {
    hero: {
      title: "Turn your projects into income",
      description:
        "Publish your project specifications on the online platform to securely connect with thousands of qualified local installers. Earn commissions with operational management.",
      "button-1": "Free sign up",
      "button-2": "How it works",
      "small-text": "Free - No commitment - Full control over your projects",
    },
    purpose: {
      title: "Designed for companies managing solar projects",
      description:
        "Earn revenue from your portfolio while keeping control if you develop solar projects but don't handle installations.",
      sections: {
        "sales-companies": {
          title: "Trusted brand",
          description:
            "You identify and manage sales opportunities and want to increase your revenue at a lower cost.",
        },
        "project-developers": {
          title: "Project developers",
          description:
            "You have real clients and projects, but need reliable local installers to complete them.",
        },
        "lead-generators": {
          title: "Lead generators",
          description:
            "You want higher quality, more transparent results rather than just simple prospect handovers.",
        },
      },
    },
    "how-it-works": {
      title: "How to become a project owner?",
      steps: {
        step1: {
          title: "Define the project brief",
          description:
            "You already have a solar opportunity. Residential or commercial, you define the scope, requirements, and timeline.",
        },
        step2: {
          title: "Publish online",
          description:
            "Choose the connection mode by defining the amounts and conditions to receive qualified offers.",
        },
        step3: {
          title: "Earn revenue",
          description:
            "Choose the installer that matches your criteria. The project progresses and you earn commissions, without operational risk.",
        },
      },
    },
    benefits: {
      title: "A smarter way to monetize operations",
      items: {
        item1: "Seamless and transparent operations",
        item2: "Control pricing, deadlines, and terms",
        item3: "Earn commissions without hiring",
        item4: "Access a national network of installers",
        item5: "Transparent offers and competitive prices",
      },
    },
    projects: {
      title: "A marketplace with real projects",
      description:
        "Installers can view, evaluate, and submit offers with full transparency.",
      "button-1": "Join",
    },
    cta: {
      title: "Start selling today",
      features: {
        feature1: "Free",
        feature2: "Secure",
        feature3: "No commitment",
      },
      "button-1": "Sign up",
    },
  },
  header: {
    home: "Home",
    solutions: "Solutions",
    "case-studies": "Case Studies",
    hardware: "Hardware",
   leads: "Leads",
  },
  home: {
    title: "The solar and storage tender platform",
    description:
      "Browse current solar and storage projects across France. Apply as a contractor to real tenders, published by project owners, commercial partners, and clients.",
    "become-sales-partner": "Become a tender issuer",
    empty: {
      title: "No projects found",
      description:
        "No tenders match your selected filters. Try adjusting your search criteria or removing some filters.",
      reset: "Reset filters",
      view: "View all projects",
    },
  },
  card: {
    live: "Live",
    offers: "offers",
    "estimated-power": "Estimated power",
    installation: "Installation",
    "view-specification": "View specifications",
    "project-types": {
      roof: "Roof",
      "ground-mount": "Ground mount",
      carport: "Carport",
      pergola: "Pergola",
      "flat-roof": "Flat roof",
    },
  },
  cta: {
    title: "Turn your solar projects into revenue without installing",
    description:
      "If you generate solar opportunities but don't handle installations, Projet Solaire lets you publish your projects, choose the installer, and earn a commission without any execution risk.",
    benefits: {
      commission: "Earn commissions on real solar projects",
      control: "Keep control over pricing and choice of installer",
      "no-risk": "No installation work or operational risk",
      projects: "Suitable for residential, commercial, and industrial projects",
    },
    "become-partner": "Become a commercial partner",
    "see-how": "See how it works",
  },
  filters: {
    "filter-by-department": "Filter by department",
    "filter-by-project-type": "Filter by project type",
    "sort-by-date": "Sort by date (most urgent)",
    "clear-all": "Clear all",
    "department-label": "Department",
    "project-type-label": "Project type",
    "project-types": {
      commercial: "Commercial",
      industrial: "Industrial",
      "public-authority": "Public authority",
    },
    sort: {
      "most-urgent": "Sort by date (most urgent)",
      newest: "Newest first",
      oldest: "Oldest first",
    },
  },
  "tender-details": {
    "project-information": "Project information",
    location: "Location",
    "published-date": "Published date",
    "fixed-price": "Fixed price",
    "be-next": "Be the next",
    "create-an-account": "Create an account",
    "log-in-to-see-project-details": "Log in to see project details",
  },
  tenders: {
    project: {
      "no-images": "No images added by the organizer",
      overview: {
        "estimated-power": "Estimated power",
        faq: {
          "questions-frequents": "Frequently asked questions about terms",
          "quoting-guidelines": {
            title: "Subject to technical inspection",
            description:
              "You submit your price proposal based on the technical file. The final quote is only issued after the mandatory technical feasibility visit. This is scheduled only once the user has chosen your offer according to your pricing and profile. If the technical visit is charged, it must be paid in advance by the user (regardless of offer), and the invoice will appear in your account.",
          },
          "cancellation-policy": {
            title: "Quote can be changed at any time",
            description:
              "Your proposal is not a quote; since the user remains anonymous your pricing is therefore not a binding conforming quote. Attention! The user is not committed by choosing your proposal; especially if your final quote is far higher than your initial pricing. One exception: if the technical visit is charged, the user must pay your fee to schedule it.",
          },
          "payments-information": {
            title: "Online payment schedule",
            description:
              "You set the deposit and balance of your price. To make things easier for users, you can't request multiple deposits. You may charge for your technical inspection, which you receive as soon as the visit is scheduled. Our service fees are charged when your client pays the deposit. Payments are automatically transferred directly to your bank account.",
          },
        },
      },
      information: {
        installation: {
          title: "Installation information",
          "service-type-provided": "Type of service",
          municipality: "Municipality",
          department: "Department",
          "estimated-installation-date": "Estimated installation date",
          "estimated-duration": "Estimated duration",
          days: "days",
        },
        "technical-visit": {
          title: "Technical visit policy",
          inspection: "Technical inspection",
          "cost-of-inspection": "Cost of technical inspection",
          "not-tempted": "Not interested",
          "visit-not-required": "Visit not required",
        },
        equipment: {
          "material-title": "Equipment",
          "equipment-provided-by-organiser":
            "The equipment below will be provided by the organizer on site.",
          "selected-equipment": "Selected equipment",
          "hardware-purchase-order-available":
            "Material purchase order available",
          "select-your-equipment": "Select your equipment",
        },
        organiser: {
          title: "Organizer",
          "project-published-by-other-installer":
            "Project published by another installer",
          "accept-the-partner": "Accepts partner T&Cs",
        },
        installer: {
          title: "Project Owner",
          "pv-company": "Project published by another PV company.",
          "terms-and-conditions": "Project Owner T&Cs",
        },
        description: {
          title: "Description",
        },
        certification: {
          title: "Required certification",
          "certification-required": "Certification requirement exists",
        },
      },
    },
    "hardware-purchase-order": {
      heading: "Hardware",
      title: "Do you want to associate a hardware purchase with this engagement?",
      "sub-title":
        "Choose below if you want to include a hardware purchase in your project.",
      alert: {
        title:
          "By associating a hardware purchase, you require the installer to buy these materials from you.",
      },
      tooltip:
        "You can only associate a purchase order if you have a Supplier account for the Warehouse",
      equipment: "Equipment",
      hardware: {
        material: "Hardware",
        "update-price": "Update price",
        purchase: {
          title: "Material purchase",
          description: "Update the price for your materials.",
        },
        "add-an-offer": "Add an offer",
        table: {
          manufacturer: "Manufacturer",
          "model-name": "Model",
          qty: "Qty",
          "number-in-stock": "Number in stock",
          allocated: "Quantity allocated",
          price: "Price",
          required: "Required",
          selected: "Selected",
          select: "Select",
          toggle: {
            panels: "Panels",
            inverters: "Inverters",
            "service-panels": "Service panels",
            "load-centers": "Breakers",
            "mounting-systems": "Mounting systems",
            "combiner-boxes": "Combiner boxes",
            "dc-optimisers": "DC optimisers",
            batteries: "Batteries",
            disconnects: "AC/DC boxes",
            tiles: "Solar tiles",
            accessories: "Accessories",
            "thermal-sensors": "Solar thermal panels",
          },
          "no-hardware": "Add your hardware equipment",
          "no-hardware-description":
            "No equipment has been registered yet.",
        },
        product: {
          power: "Power",
          type: "Type",
          "number-of-phases": "Number of phases",
          from: "from",
          unit: "unit",
          "see-the-offers": "See offers",
          Quantity: "Quantity",
          pieces: "Pieces",
          "delivery-cost": "Delivery cost",
          remove: "Remove",
        },
        "product-offer": {
          title: "Material purchase",
          description: "Update the price for your materials",
          "offers-available": "Available offers",
          "add-an-offer": "Add an offer",
          power: "Power",
          kind: "Type",
          "number-of-phases": "Number of phases",
          "pcs-available": "pcs available",
          price: "Price",
          unit: "unit",
          choose: "Choose",
          choosen: "chosen",
        },
      },
    },
  },
  breadcrumb: {
    "go-back": "Back to marketplace",
    "tender-details": "Project details",
  },
}
